import React, { Component } from 'react';

export default class Chapter1 extends Component {
  render() {
    return (
      <div>
        <div className="medium-padding joysetter-header">
          <h6 className="white">Jet Lag Tool Kit</h6>
          <h1 className="white">Chapter 7: Humor</h1>
          <p className="white"><b>How to let go through laughter</b></p>
        </div>
        <div className="toolkit-content">
          <ol >
            <li>Embrace your inner goofball. Let your weird, embarrassing, silly self thrive and stop judging so harshly. Vow to no longer take yourself or life so seriously.
            </li>
            <li>If something really upsets you, try to laugh at it. Appreciate life’s humor and impeccable timing. Speed up the amount of time it takes to go from tragedy to comedy by accepting what happened and then letting it go.
            </li>
            <li>Smile and laugh more freely and you will start to loosen up. Even if this means faking it ’til you make it. Smile and laugh even if you don’t feel like it, and you will start to feel like it.
            </li>
            <li>Play! Not everything you do needs to have a purpose. Do something for the sheer enjoyment of it and you will start to notice your productivity increase in other areas of your life. Play ironically fosters productivity.
            </li>
            <li>Remember, if you actively look for the humor in life, you will find it.
            </li>
          </ol>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/toolkits/chapter7.js